import {
  SCHEDULER_TYPE,
  SCHEDULERS,
} from "domains/inference/constants/Schedulers";

export default function isLCMScheduler(scheduler: SCHEDULER_TYPE | undefined) {
  if (!scheduler) return false;
  return SCHEDULERS[scheduler] === SCHEDULERS.LCMScheduler;
}
